export function sortRecordsByKey<T>(records: T[], keyPath: string, ascending: boolean = true): T[] {
  // Function to safely access properties, nested or otherwise
  const getValueByPath = (object: any, path: string): any => {
    // Handles both nested and non-nested properties
    return path.split('.').reduce((o, k) => (o === null || o === undefined ? o : o[k]), object);
  };

  return records.sort((a, b) => {
    const valueA = getValueByPath(a, keyPath);
    const valueB = getValueByPath(b, keyPath);

    // Handle null or undefined values
    if (valueA == null && valueB != null) return ascending ? 1 : -1;
    if (valueB == null && valueA != null) return ascending ? -1 : 1;
    if (valueA == null && valueB == null) return 0;

    // Compare strings in a case-insensitive manner
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return ascending ? valueA.toLowerCase()?.localeCompare(valueB.toLowerCase()) : valueB.toLowerCase()?.localeCompare(valueA.toLowerCase());
    }
    // Compare numbers
    else if (typeof valueA === 'number' && typeof valueB === 'number') {
      return ascending ? valueA - valueB : valueB - valueA;
    }
    // Fallback for non-comparable types or if types do not match
    else {
      return 0;
    }
  });
}